import ReactMarkdown, { Components } from "react-markdown";
import gfm from "remark-gfm";

import CodeSnippetInline from "ds/components/CodeSnippetInline";
import Link from "ds/components/Link";

const components: Partial<Components> = {
  a: ({ href, children }) => (
    <Link href={href} size="inherit" noEllipsis target="_blank" rel="noopener noreferrer">
      {children}
    </Link>
  ),
  code: ({ children }) => <CodeSnippetInline>{String(children)}</CodeSnippetInline>,
};

type MaintenanceMessageProps = {
  children: string;
};

const MaintenanceMessage = ({ children }: MaintenanceMessageProps) => (
  <ReactMarkdown
    remarkPlugins={[gfm]}
    allowedElements={["a", "strong", "em", "code"]}
    components={components}
    unwrapDisallowed
    skipHtml
  >
    {children}
  </ReactMarkdown>
);

export default MaintenanceMessage;
